export const removeDiacritics = (input: string) => {
  return input?.normalize('NFD').replace(/\p{Diacritic}/gu, '')
}
